import { Accordion, Text, Box } from '@nimbus-ds/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { TaxRulesTable } from './components';
import { TaxRuleType } from './types';

import './TaxRules.scss';

interface TaxRulesProps {
  readonly taxRules: TaxRuleType[];
}

function TaxRulesField({ taxRules }: TaxRulesProps) {
  const t = useTranslationCatalog('products.detail.invoiceSettings');
  const hasTaxRules = taxRules.length > 0;

  return (
    <div className="stratus--container-tax-rules">
      <Accordion>
        <Accordion.Item index="0">
          <Accordion.Header
            subtitle={t('infoTaxRules')}
            title={t('titleTaxRules')}
            borderBottom="base"
          />
          <Accordion.Body
            borderBottom="base"
            borderTop={hasTaxRules ? 'none' : 'base'}
          >
            {hasTaxRules ? (
              <TaxRulesTable taxRules={taxRules} />
            ) : (
              <Box>
                <Text>{t('noTaxRules')}</Text>
              </Box>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export default TaxRulesField;
